import React, { useState, useEffect } from 'react';
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import  GetSchemes  from '../../Dropdowns/getSchemes';
import Portability_Sale_District from './Portability_Sale_District';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Portability_Sale_Int = ({ heading }) => {
    const [renderContent, setRenderContent] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [loadingTable, setLoadingTable] = useState(false); 
    const [loading,setLoading]=useState(false)
    const [selectedscheme, setSelectedscheme] = useState(null);
    const handleSubmit = () => {
        const month = document.getElementById('month').value;
        const year = document.getElementById('year').value;
        const schemeVal = document.getElementById('scheme_id').value;
        const schemeId = parseInt(schemeVal, 10);

        if (!month || month === '0') {
            alert('Please select Month');
            return;
        }
        if (!year || year === '0') {
            alert('Please select Year');
            return;
        }
        if (  Number.isNaN(schemeId)) {
            alert('Please select commodity');
            return;
        }

        setSelectedMonth(month);
        setSelectedYear(year);
        setSelectedscheme(schemeId);
        setLoadingTable(true);
        setTimeout(() => {
            setRenderContent(<Portability_Sale_District month={month} year={year} schemeId={schemeId} />);
            setLoadingTable(false);
        }, 10);
    };
        const handleLoadingChange = (isLoading) => {
       setLoading(isLoading);
   };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="50%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={8}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Month</td>
                                    <td><GetMonths onLoadingChange={handleLoadingChange}  /></td>
                                    <td>Year</td>
                                    <td><GetYears onLoadingChange={handleLoadingChange}  /></td>
                                    <td>Scheme</td>
                                    <td><GetSchemes onLoadingChange={handleLoadingChange} /></td>
                                </tr>
                                <tr>
                                    <td colSpan={8} align="center">
                                        <button 
                                            onClick={handleSubmit} 
                                            className="button button2" 
                                        >
                                            Submit
                                        </button>
                                        <button className="button button2">
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />

                    {loadingTable && (
                              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={30} />
      </Box>
                    )}

                    <br />
                    <div id="details1">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default Portability_Sale_Int;
